import { render, staticRenderFns } from "./BannerPortal.vue?vue&type=template&id=1cb85e29&scoped=true"
import script from "./BannerPortal.vue?vue&type=script&lang=js"
export * from "./BannerPortal.vue?vue&type=script&lang=js"
import style0 from "./BannerPortal.vue?vue&type=style&index=0&id=1cb85e29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb85e29",
  null
  
)

export default component.exports